import { render, staticRenderFns } from "./PainelServicos.vue?vue&type=template&id=e9cdd90c&scoped=true"
import script from "./PainelServicos.vue?vue&type=script&lang=js"
export * from "./PainelServicos.vue?vue&type=script&lang=js"
import style0 from "./PainelServicos.vue?vue&type=style&index=0&id=e9cdd90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cdd90c",
  null
  
)

export default component.exports